import { Subject } from 'rxjs';

export class FocusStream {
  searchSubject = new Subject();
  inputSubject = new Subject();
  search$ = this.searchSubject.asObservable();
  input$ = this.inputSubject.asObservable();

  constructor() {}
}

/*
 * Service focusStreams
 */
angular.module('posApp').factory('focusStreams', () => {
  return new FocusStream();
});
